import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { DialogTitle } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});


class PopupError extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            error: '',
            actionAfterClose: null
        };

        this.handleClose = this.handleClose.bind(this);
    }

    showError(msg, actionAfterClose) {
        this.setState({
            open: true,
            error: msg,
            actionAfterClose
        });
    }

    handleClose(){
        this.setState({
            open: false,
        }, this.state.actionAfterClose);
    }

    render() {
        return (
            <Dialog
                open={this.state.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.handleClose}
            >
                <DialogTitle>Une erreur s'est produite !</DialogTitle>
                <DialogContent>
                    <p>{this.state.error}</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="secondary">
                        OK
                    </Button>
                </DialogActions>
        </Dialog>
        );
    }
}

export default PopupError;